(function ($)
{
	window.ZoomTool = function () { };
	ZoomTool.prototype = new MouseTrackingTool();
	ZoomTool.prototype.TOOL_ID = "ZoomTool";

	// these are used to set new interval/periods for custom timeframes
	ZoomTool.prototype.DAY_THRESHOLD = 30;
	ZoomTool.prototype.HOUR_THRESHOLD = 5;

	ZoomTool.prototype.Init = function (oChart) {
		this._baseInit(oChart);
		this._setCursors();
		this._setOverlays();
		this._applyEvents();
		this._isZooming = false;
	};
	//Overrides
	ZoomTool.prototype.Enable = function () {
		this._enabled = true;
		this._startTracking();
		if (this._cursors) {
			this._cursors.removeClass("disabled");
		}
	};
	ZoomTool.prototype.Disable = function () {
		this._enabled = false;
		this._stopTracking();
		this._cursors.addClass("disabled");
		this._overlays.addClass("disabled");
	};
	ZoomTool.prototype.Reset = function () {
		$(this._cursors).remove();
		$(this._overlays).remove();
		this._setCursors();
		this._setOverlays();
		this._applyEvents();
		this._startTracking();
	};
	//Display
	ZoomTool.prototype._setCursors = function () {
		this._cursors = $();
		var oTool = this;
		this._getPanelElements().each(function () {
			var jPanel = $(this);
			var jCursor = oTool._buildCursor(jPanel);
			jPanel.append(jCursor);
			oTool._cursors = oTool._cursors.add(jCursor);
		});
	};
	ZoomTool.prototype._setOverlays = function () {
		this._overlays = $();
		var oTool = this;
		this._getPanelElements().each(function () {
			var jPanel = $(this);
			var jOverlay = oTool._buildOverlay(jPanel);
			jPanel.append(jOverlay);
			oTool._overlays = oTool._overlays.add(jOverlay);
		});
	};
	ZoomTool.prototype._buildCursor = function (jPanel) {
		var jCursor = $("<div class='cursor zoom-tool-cursor'></div>");
		jCursor.height(jPanel.height());
		//Keep mousedown event from firing twice
		jCursor.mousedown(function (e) { e.stopPropagation(); return false; });
		return jCursor;
	};
	ZoomTool.prototype._buildOverlay = function (jPanel) {
		var jOverlay = $("<div class='overlay zoom-tool-overlay disabled'></div>");
		jOverlay.height(jPanel.height());
		//jOverlay.css({ "margin-left": "-" + jPanel.offset().left + "px" });
		return jOverlay;
	};
	ZoomTool.prototype._setZoomState = function (bZooming) {
		this._isZooming = bZooming;
		if (this._overlays) {
			this._overlays.toggleClass("disabled", !bZooming);
		}
	};
	ZoomTool.prototype._sizeOverlays = function (nPos) {
		var oData = this._getDataForLatestXCoord(nPos);
		if (!oData) { return; }
		var nMouse = oData.CloseX;
		if (nMouse > this._zoomStart) { //left of overlay is start of mouse drag
			this._overlays.css({ width: nMouse - this._zoomStart + "px", left: (this._zoomStart - this._offsetX) + "px" });
		
		} else { //left of box is mouse position
			this._overlays.css({ width: (this._zoomStart - nMouse) + "px", left: nMouse - this._offsetX + "px" });
		}
	};
	ZoomTool.prototype._setChartTimeRangeByPixelValues = function (nPointA, nPointB) {
		var nStart = Math.min(nPointA, nPointB);
		var nEnd = Math.max(nPointA, nPointB);
		var tStart = this._chart.PricePanel.GetNearestDateFromXCoord(nStart);
		var tEnd = this._chart.PricePanel.GetNearestDateFromXCoord(nEnd);
		this._chart.SetDateRange( //shouldn't be price panel specific
			tStart,
			tEnd
		);
		this._setCustomTimeFrameInterval(tStart, tEnd);
		if (tStart == tEnd) { return false; }
		this._chart.Broadcast("CustomDateRangeSelected", { start: tStart, end: tEnd });
		this._chart.Update();
	};

	ZoomTool.prototype._setCustomTimeFrameInterval = function (tStart, tEnd) {
		var nDays = tEnd - tStart;
		this._setIntervalPeriodByNumberOfDays(nDays, tStart);
	};

	ZoomTool.prototype._setIntervalPeriodByNumberOfDays = function (nDays, tStart) {
		var nInterval = 1;
		var sPeriod = "Week";

		// TT0175386 - if the start date is more than 21 days old, default to "day" period
		var tTwentyOneDaysAgo = this._jsToMsDate(new Date()) - 21;

		if (nDays >= this.DAY_THRESHOLD || tStart <= tTwentyOneDaysAgo) {
			sPeriod = "Day";
		}
		else if (nDays >= this.HOUR_THRESHOLD) {
			sPeriod = "Hour";
		}
		else {
			nInterval = 5;
			sPeriod = "Minute";
		}
		this._chart.SetPeriod(sPeriod);
		this._chart.SetInterval(nInterval);
	};

	//Event Application
	ZoomTool.prototype._applyEvents = function () {
		this._getPanelElements()
			.mouseover(this._handleMouseOver.eventContext(this))
			.mouseout(this._handleMouseOut.eventContext(this))
			.mousedown(this._handleMouseDown.eventContext(this))
			.mouseup(this._handleMouseUp.eventContext(this))

		this._cursors
			.mousedown(this._handleMouseDown.eventContext(this))
			.mouseup(this._handleMouseUp.eventContext(this))

	};
	//Event handlers
	ZoomTool.prototype._handleMouseOver = function (oEvent, oEl) {
		this._offsetX = $(oEl).offset().left;
		$(oEl).addClass("tool-active");
	};
	ZoomTool.prototype._handleMouseOut = function (oEvent, oEl) {
		$(oEl).removeClass("tool-active");
	};
	ZoomTool.prototype._handleMouseMove = function (oMouse) {
		this._positionCursors(oMouse);
		if (this._isZooming) {
			this._sizeOverlays(oMouse.x);
		}
	};
	ZoomTool.prototype._positionCursors = function (oMouse) {
		var oData = this._getDataForLatestXCoord(oMouse.x - this._offsetX);
		if (!oData) { return; }
		this._cursors.css({ left: oData.CloseX + "px" });
	};
	ZoomTool.prototype._handleMouseDown = function (oEvent, oEl) {
		if (!this._enabled) { return false; }
		this._setZoomState(true);
		this._zoomStart = oEvent.pageX;
		oEvent.stopPropagation();
	};
	ZoomTool.prototype._handleMouseUp = function (oEvent, oEl) {
		this._setZoomState(false);
		if (!this._enabled) { return false; }
		this._overlays.css({ width: 0 });
		var nZoomEnd = oEvent.pageX;
		if (nZoomEnd == this._zoomStart) { return false; }
		this._setChartTimeRangeByPixelValues(this._zoomStart, nZoomEnd);
	};
	ZoomTool.prototype._handleOutputDataUpdate = function (oEvent, oData) {
		this.Reset();
	};


	// this needs to be referenced from date.js in the jslib
	// figured we could change that when we convert this to a nuget package?
	ZoomTool.prototype._jsToMsDate = function (jsdate) {
		var timezoneOffset = jsdate.getTimezoneOffset() / (60 * 24);
		var msDateObj = (jsdate.getTime() / 86400000) + (25569 - timezoneOffset);
		return msDateObj;
	};
})(jQuery);